export default () => {
  const apiHost = 'https://europe-west2-foodtryb.cloudfunctions.net';
  const clientHost = 'https://tryb.cc';

  const baseURL = `${apiHost}/web`;
  const FB_APP_ID = '2703351543230999';

  const stripeConfig = {
    liveMode: true,
    publicKey: 'pk_live_51HuI4yCyaouDToD1Y37UoBoz9tCBInkWNahRcJwFTDmJQjmTFTJwtX17VUs1dDPQ4Ucn6v894XKgYEg92W8hvIx900LP8xHaeO',
  };

  const firebaseConfig = {
    apiKey: 'AIzaSyBisUf2aItVoaGaFdTGgTTnsI7Affo-nDI',
    // https://firebase.google.com/docs/auth/web/redirect-best-practices
    authDomain: 'tryb.cc',
    databaseURL: 'https://foodtryb.firebaseio.com',
    storageBucket: 'foodtryb.appspot.com',

    projectId: 'foodtryb',
    messagingSenderId: '23230854467',
    appId: '1:23230854467:web:2356b288bfb629e7772bf6',
    measurementId: 'G-JHZ6QD4Z8Q',
  };

  const getTemplateCategories = () => import('@/constants/templates/templatesProduction').then(({ CATEGORIES }) => CATEGORIES);

  return {
    baseURL,
    clientHost,
    FB_APP_ID,
    firebaseConfig,
    stripeConfig,
    getTemplateCategories,
  };
};
